import { RouteRecordRaw } from 'vue-router';

const EMPLOYER_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'EmployersOverview',
      component: () => import('@/modules/employers/pages/EmployersOverview.vue'),
   },
   {
      path: ':id',
      name: 'EmployerDetails',
      component: () => import('@/modules/employers/pages/EmployerDetails.vue'),
      children: [
         {
            path: 'teams',
            alias: '',
            name: 'EmployerTeams',
            component: () => import('@/modules/employers/components/EmployerTeams.vue'),
         },
      ],
   },
];

export default EMPLOYER_ROUTES;
